// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronDownIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 15a1 1 0 01-.71-.29l-4-4a1 1 0 111.42-1.42l3.29 3.3 3.29-3.3a1 1 0 011.42 1.42l-4 4A1 1 0 0112 15z" fill="currentColor"/></svg>'} />;

ChevronDownIcon.displayName = 'ChevronDownIcon';

export default ChevronDownIcon;
